// Helpers to produce backgrounds that combine color + opacity + optional image.
// Used by PasswordZone, MediaZone, Ticker and the new CARDS layout so that
// the user can apply transparency or background images per zone.

const clamp01 = (n) => (Number.isFinite(n) ? Math.min(1, Math.max(0, n)) : 1);

export const hexToRgba = (hex, opacity = 1) => {
  if (!hex || typeof hex !== "string") return `rgba(255,255,255,${clamp01(opacity)})`;
  let h = hex.replace("#", "").trim();
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (h.length !== 6) return `rgba(255,255,255,${clamp01(opacity)})`;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${clamp01(opacity)})`;
};

/**
 * Build an inline-style object for a zone background.
 *  - color: hex (#FFFFFF)
 *  - opacity: 0..1 (default 1, opaque)
 *  - image: URL string (optional). When set, the color is layered as an
 *           overlay on top of the image with its opacity, allowing graceful
 *           tinted backgrounds.
 */
export const bgStyle = (color, opacity = 1, image = "") => {
  const op = clamp01(opacity);
  if (image && image.trim()) {
    const rgba = hexToRgba(color, op);
    return {
      backgroundColor: hexToRgba(color, 1), // fallback while image loads
      backgroundImage: `linear-gradient(${rgba}, ${rgba}), url(${image})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    };
  }
  return { backgroundColor: hexToRgba(color, op) };
};
